export const EMAIL_PATTERN =
  // eslint-disable-next-line max-len
  /^[-!#$&*+0-9=A-Z_a-z~](\.?[-!#$&*+0-9=A-Z_a-z~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/

export function validateEmail(input: string) {
  return input.match(EMAIL_PATTERN) !== null
}
